import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import NotFound from '@/pages/NotFound';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import AdminDashboardPage from '@/pages/admin/page';
import AdminLeadsPage from '@/pages/admin/leads/page';
import AdminClientesPage from '@/pages/admin/clientes/page';
import ClientDetailPage from '@/pages/admin/clientes/[id]/page';
import AdminProjetosPage from '@/pages/admin/projetos/page';
import ScrumIndexPage from '@/pages/admin/scrum/page';
import BacklogPage from '@/pages/admin/scrum/[projectId]/backlog';
import BoardPage from '@/pages/admin/scrum/[projectId]/board';
import PricingPage from '@/pages/admin/scrum/[projectId]/pricing';
import FinanceiroPage from '@/pages/admin/financeiro/page';
import UsuariosPage from '@/pages/admin/usuarios/page';
import UserDashboardPage from '@/pages/app/page';
import ClientProjectPage from '@/pages/app/projeto/[id]/page';
import { PrivateRoute, PublicRoute } from '@/components/feature/PrivateRoute';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: (
      <PublicRoute>
        <LoginPage />
      </PublicRoute>
    ),
  },
  {
    path: '/cadastro',
    element: (
      <PublicRoute>
        <RegisterPage />
      </PublicRoute>
    ),
  },
  {
    path: '/admin',
    element: (
      <PrivateRoute requireAdmin>
        <AdminDashboardPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/leads',
    element: (
      <PrivateRoute requireAdmin>
        <AdminLeadsPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/clientes',
    element: (
      <PrivateRoute requireAdmin>
        <AdminClientesPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/clientes/:id',
    element: (
      <PrivateRoute requireAdmin>
        <ClientDetailPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/projetos',
    element: (
      <PrivateRoute requireAdmin>
        <AdminProjetosPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/projetos/novo',
    element: (
      <PrivateRoute requireAdmin>
        <AdminProjetosPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/scrum',
    element: (
      <PrivateRoute requireAdmin>
        <ScrumIndexPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/scrum/:projectId/backlog',
    element: (
      <PrivateRoute requireAdmin>
        <BacklogPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/scrum/:projectId/board',
    element: (
      <PrivateRoute requireAdmin>
        <BoardPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/scrum/:projectId/pricing',
    element: (
      <PrivateRoute requireAdmin>
        <PricingPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/financeiro',
    element: (
      <PrivateRoute requireAdmin>
        <FinanceiroPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/admin/usuarios',
    element: (
      <PrivateRoute requireAdmin>
        <UsuariosPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/app',
    element: (
      <PrivateRoute>
        <UserDashboardPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/app/projeto/:id',
    element: (
      <PrivateRoute>
        <ClientProjectPage />
      </PrivateRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
